const linkPattern = /\[([^\]\n]{1,160})\]\((https?:\/\/[^\s)]+)\)/gi;
function escapeHtml(value) {
    return value
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;');
}
export function brandingMessageToHtml(message) {
    let html = '';
    let offset = 0;
    for (const match of message.matchAll(linkPattern)) {
        const index = match.index ?? 0;
        const label = match[1] ?? '';
        const href = match[2] ?? '';
        html += escapeHtml(message.slice(offset, index));
        try {
            const url = new URL(href);
            if (!['http:', 'https:'].includes(url.protocol))
                throw new Error('Unsupported protocol');
            html += `<a href="${escapeHtml(url.toString())}" target="_blank" rel="noopener noreferrer">${escapeHtml(label)}</a>`;
        }
        catch {
            html += escapeHtml(match[0]);
        }
        offset = index + match[0].length;
    }
    return html + escapeHtml(message.slice(offset));
}
//# sourceMappingURL=branding-markup.js.map